import { FC } from 'react';
import searchIcon from 'assets/icons/select-search-result.svg';
import { IOptionLabel } from 'features/searchSchedule/models/types';

import styles from './styles.module.scss';

export const OptionLabel: FC<IOptionLabel> = ({
  id,
  value,
  styleImg,
  styleText,
}) => {
  return (
    <div className={styles['option']} key={`${id}`}>
      <div className={styles['option__content']}>
        <img
          className={styles['option__image']}
          src={searchIcon}
          alt="search"
          style={styleImg}
        />
        <span style={styleText}>{value}</span>
      </div>
    </div>
  );
};
